import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4bff9600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "idor" }
const _hoisted_2 = { class: "idor__elm" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idor__elm-header-text" }, "Опции", -1))
const _hoisted_4 = {
  key: 0,
  class: "idor__elm-body"
}
const _hoisted_5 = { class: "idor__elm-body-switcher" }
const _hoisted_6 = {
  key: 0,
  class: "idor__elm-body-item"
}
const _hoisted_7 = { class: "idor__elm-body-item-checkbox" }
const _hoisted_8 = { class: "idor__elm-body-item-text" }
const _hoisted_9 = { class: "idor__elm-body-item-text" }
const _hoisted_10 = {
  key: 0,
  class: "idor__elm-body-info"
}
const _hoisted_11 = {
  key: 1,
  class: "idor__elm-body-info"
}
const _hoisted_12 = {
  key: 2,
  class: "idor__elm-body-footer"
}
const _hoisted_13 = { class: "idor__elm-body-footer-option" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idor__elm-body-footer-option-label" }, " Опции: ", -1))
const _hoisted_15 = {
  key: 0,
  class: "idor__elm-body-footer-option-item"
}
const _hoisted_16 = { class: "idor__elm-body-footer-option-item-label" }
const _hoisted_17 = { class: "idor__elm-body-footer-option-item-label" }
const _hoisted_18 = { class: "idor__elm-body-footer-option-item-label" }
const _hoisted_19 = {
  key: 0,
  class: "idor__elm-body-footer-option-label-ins"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idor__elm-body-footer-option-label-ins-txt" }, " Продление инстанса: ", -1))
const _hoisted_21 = { class: "idor__elm-body-footer-option-label-ins-cost" }
const _hoisted_22 = { class: "idor__elm-body-footer-option-label-ins-cost" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idor__elm-body-footer-option-label" }, " Продление опций: ", -1))
const _hoisted_25 = {
  key: 0,
  class: "idor__elm-body-footer-option-item"
}
const _hoisted_26 = { class: "idor__elm-body-footer-option-item-label" }
const _hoisted_27 = { class: "idor__elm-body-footer-option-item-label" }
const _hoisted_28 = { class: "idor__elm-body-footer-option-item-label" }
const _hoisted_29 = { class: "idor__elm-body-footer-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconChevronDown = _resolveComponent("IconChevronDown")!
  const _component_UiSwitcher = _resolveComponent("UiSwitcher")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickShowOptions && _ctx.onClickShowOptions(...args))),
        class: "idor__elm-header"
      }, [
        _hoisted_3,
        _createElementVNode("div", {
          class: _normalizeClass(
						_ctx.isShowOptions
							? 'idor__elm-header-icon-down'
							: 'idor__elm-header-icon-up'
					)
        }, [
          _createVNode(_component_IconChevronDown)
        ], 2)
      ]),
      (_ctx.isShowOptions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.paymentBeforeInstance && _ctx.paymentBeforeInstance(...args))),
                class: _normalizeClass(
							_ctx.isChecked
								? 'idor__elm-body-switcher-on-left'
								: 'idor__elm-body-switcher-off'
						)
              }, " Оплата до инстанса ", 2),
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.paymentPerMonth && _ctx.paymentPerMonth(...args))),
                class: _normalizeClass(
							!_ctx.isChecked
								? 'idor__elm-body-switcher-on-right'
								: 'idor__elm-body-switcher-off'
						)
              }, " Оплата на месяц ", 2)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (_ctx.excludePaid(item.id))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_UiSwitcher, {
                          "is-array-items": true,
                          name: `${item.name}`,
                          "item-id": Number(item.id),
                          onCheckedItem: _ctx.checked
                        }, null, 8, ["name", "item-id", "onCheckedItem"])
                      ]),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(item.cost) + " руб. ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.isChecked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Опции будут оплачены до даты окончания инстанса. "))
              : _createCommentVNode("", true),
            (!_ctx.isChecked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Опции будут оплачены на месяц, а инстанс будет автоматически продлён. "))
              : _createCommentVNode("", true),
            (!_ctx.isPayMonthDisable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsMap, (option, idx) => {
                      return (_openBlock(), _createElementBlock("div", { key: idx }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionList, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            (item.id === option[0])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.name) + ": ", 1),
                                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.cost) + " руб. ", 1),
                                  _createElementVNode("div", _hoisted_18, " до " + _toDisplayString(_ctx.instanceExpired), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    }), 128)),
                    (!_ctx.isChecked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.channelCost()) + " руб. ", 1),
                          _createElementVNode("div", _hoisted_22, " до " + _toDisplayString(_ctx.instanceExpired), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isChecked && _ctx.isPaidOptionsNeedRenew)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _hoisted_24,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paidOptions, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              (item.need_renew === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.getOptionById(item.option_id).name) + ": ", 1),
                                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.recalcOptionCost(item.option_id)) + " руб. ", 1),
                                    _createElementVNode("div", _hoisted_28, " до " + _toDisplayString(_ctx.instanceExpired), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_UiButton, {
                      onClick: _ctx.onClickPay,
                      label: `Оплатить ${_ctx.payBtnInfo} руб`,
                      "background-color": "var(--theme-color)",
                      "border-color": "var(--theme-color)",
                      color: "rgb(255, 255, 255)"
                    }, null, 8, ["onClick", "label"]),
                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.paidOptionsCalculate), 513), [
                      [_vShow, false]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}